<h1 class="h3 mb-2 text-gray-800">Casos</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Comprobante de depósito de tratamiento</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label>
                        Comprobante recibido
                    </label>
                    <div>
                        <a class="caso-foto" href="{{getImageUrl('comprobante-tratamiento')}}" target="_blank"><img
                                src="{{getImageUrl('comprobante-tratamiento')}}" /></a>
                    </div>
                    <label>
                        Dirección de entrega:
                    </label>
                    <p>
                        {{refinamiento.direccion_entrega}}
                    </p>
                    <label>Ubicación de entrega:</label>
                    <div>
                        <google-map width="750px" height="450px" [center]="center" [zoom]="zoom">
                            <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title"
                                [options]="marker.options">
                            </map-marker>
                        </google-map>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success" (click)="aprobarComprobante()">Aprobar
                        comprobante</button>&nbsp;
                    <button type="submit" class="btn btn-primary" (click)="rechazar(rechazarModal)">Rechazar
                        comprobante</button>&nbsp;
                    <a [routerLink]="'/casos/'+refinamiento.caso_id+'/verpaciente'" class="btn btn-link">Volver</a>

                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #rechazarModal let-modal>
    <form name="form" (ngSubmit)="f.form.valid && rechazarComprobante()" #f="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Rechazar</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="dateOfBirth">Motivo de Rechazo</label>
                <textarea [(ngModel)]="refinamiento.motivo_rechazo" #motivoRechazo="ngModel" class="form-control"
                    name="motivoRechazo" [ngClass]="{'is-invalid':  f.submitted && motivoRechazo.invalid}"
                    required></textarea>
                <div *ngIf="f.submitted && motivoRechazo.invalid" class="invalid-feedback">
                    <div *ngIf="motivoRechazo.errors.required">El motivo es requerido</div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Confirmar
                Rechazo</button>
        </div>
    </form>
</ng-template>